import React from 'react';
import DataTable from '../../DataTable';
import { inject, observer } from 'mobx-react';
import Spinner from "../../Spinner";
import { Link } from "react-router";
import WorkOrderInfoTable from "./WorkOrderInfoTable";

@inject('ticketStore', 'workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'userStore', 'inventoryItemStore', 'stationStore', 'folderStore')
@observer
class WorkOrderList extends React.Component {

  slug = 'monitoring/work_order/tabular';

  actionColumn = [
    { key: 'title', label: 'Title' },
    { key: 'station', label: 'Station' },
    { key: 'ticket', label: 'Ticket' },
    { key: 'status', label: 'Status' },
    { key: 'priority', label: 'Priority' },
    { key: 'maintenance_type', label: 'Maintenance Type' },
    { key: 'creation_date', label: 'Creation Date' },
    { key: 'scheduled_date', label: 'Scheduled Date' },
    { key: 'completion_deadline', label: 'Completion Deadline' },
    { key: 'created_by_user.name', label: 'Created By' },
    { key: 'assigned_to_user.name', label: 'Assigned To' },
  ];

  // actions = [
  //   { label: 'View', link: '/monitoring/work_order/tabular/{id}/view' },
  // ];

  componentWillMount() {
    const { ticketStore, workOrderStore, inventoryItemStore } = this.props;

    ticketStore.items.length === 0 && ticketStore.fetchItems();
    workOrderStore.items.length === 0 && workOrderStore.fetchItems();
    inventoryItemStore.items.length === 0 && inventoryItemStore.fetchItems();

    workOrderStore.selectedTime = 0;
    workOrderStore.timeRange = [];
  }

  handleDelete = (idOrIds) => this.props.workOrderStore.removeItems(idOrIds);

  render() {
    const { workOrderView, location: { query: { ticket_id } } } = this.props;
    const { workOrderStore, workOrderStatusStore, priorityStore, maintenanceTypeStore, userStore, inventoryItemStore, stationStore, folderStore } = this.props;

    if (folderStore.isLoading || stationStore.isLoading || workOrderStore.isLoading || workOrderStatusStore.isLoading || priorityStore.isLoading || maintenanceTypeStore.isLoading || userStore.isLoading) {
      return <Spinner />;
    }

    if (!!workOrderView) return workOrderView;

    let items = workOrderStore.filteredWorkOrders.map(item => {
      const priority = priorityStore.findById(item.priority_id),
        maintenance_type = maintenanceTypeStore.findById(item.maintenance_type),
        created_by = userStore.findById(item.created_by),
        assigned_to = userStore.findById(item.assigned_to),
        status = workOrderStatusStore.findById(item.status_id);

      return {
        id: item.id,
        station: item.station && <ul>{
          item.station.map(s => {
            const station = stationStore.findById(s.id);

            return station ? <li key={`work-order-${item.id}-station-${s.id}`}><Link to={`/station/${station.id}/monitoring`}>{station.name}</Link></li> : null;
          })}</ul>,
        ticket: item.ticket && <ul>
          {item.ticket.map(t => <li key={`work-order-${item.id}-station-${t.id}`}>
            <Link to={`/monitoring/ticket/tabular/${t.id}/view`}>
              {t.summary || 'View'} {!!t.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}
            </Link></li>)
          }
        </ul>,
        title: <Link to={`/monitoring/work_order/tabular/${item.id}/view`}>{item.title || 'View'} {!!item.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}</Link>,
        // item: inventoryItem && inventoryItem.serial_no,
        priority: priority && priority.caption,
        maintenance_type: maintenance_type && maintenance_type.caption,
        creation_date: item.creation_date,
        scheduled_date: item.scheduled_date,
        completion_deadline: item.completion_deadline,
        color: item.color,
        created_by: created_by && created_by.name,
        assigned_to: assigned_to && assigned_to.name,
        status: status && status.caption,
        assigned_to_user: item.assigned_to_user,
        created_by_user: item.created_by_user,
      }
    });

    return (
      <div className='full-width'>
        <div className='ticket-list-map'>
          <div className='flex-grow overflow-x-scroll'>
            <div>
              <DataTable
                data={ticket_id ? items.filter(item => +item.ticket_id === +ticket_id) : items}
                slug={this.slug}
                columns={this.actionColumn}
                onDelete={this.handleDelete}
                allowAdd
                allowEdit
                allowDelete
                // actions={this.actions}
                resource='maintenance'
              />
            </div>
          </div>
          <div>
            <WorkOrderInfoTable />
          </div>
        </div>
        {this.props.children && this.props.children}
      </div>
    );
  }
}

export default WorkOrderList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderList.js